import styled from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';

export const Container = styled.div`
  position: relative;
`;

export const BlurContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 1rem;
  left: 0;
`;

export const Blur = styled.img`
  ${mediaQuery.minWidth.wide} {
    display: none;
  };
`;

export const BlurImage = styled(Blur)`
  height: 50rem;
`;

export const BlurImage2 = styled(Blur)`
  margin-top: 200px;
  height: 45rem;
`;

export const BlurImage3 = styled(Blur)`
  margin-top: 100px;
  height: 45rem;
`;

export const BlurImage4 = styled(Blur)`
  margin-top: 270px;
  height: 45rem;
`;

export const MainContainer = styled.div`
  max-width: 1240px;
  margin: 0 auto;
  padding-left: 20px;

  ${mediaQuery.maxWidth.tablet} {
    display: none;
  };
`;

export const MobileContainer = styled.div`
  display: none;

  ${mediaQuery.maxWidth.tablet} {
    display: flex;
    flex-direction: column;
  };
`;

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
`;


export const ImagesSection = styled.div`
  flex: 1;
  justify-content: flex-end;
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: 220px;
  padding: 1rem;
`;

export const Image = styled.img`
  min-height: 560px;
  max-width: 720px;
  width: 50%;
  object-fit: contain;
`;

export const Title = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
  font-size: 3rem;
  margin: 0;
  line-height: 100%;
  z-index: 1;
`;

export const TextContainer = styled.div<{ isVisible: boolean }>`
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;
  position: -webkit-sticky;
  position: sticky;
  top: 50%;
  width: 50%;
  height: 200px;
  max-width: 424px;
  align-items: center;
  justify-content: center;
`;

export const Text = styled.div`
  font-size: 20px;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  padding-top: 12px;
  padding-bottom: 8px;
`;

export const HighlightedTitle = styled.span`
  background: linear-gradient(90deg, #B866FF 0%, #F34675 59.91%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
`;

export const RemainingTitle = styled.span``;

export const Description = styled.div`
  margin-top: 2rem;
  color: rgba(255, 255, 255, 0.75);
  font-size: 20px;
  line-height: 32px;
`;